import { SimpleGrid } from '@chakra-ui/react';

import { Flex } from 'src/components/UI/Flex';
import { Skeleton } from 'src/components/UI/Skeleton';

export function PersonalDataFormSkeleton() {
  return (
    <Flex
      flexDirection={'column'}
      gap={'20px'}
      bgColor={{
        base: 'transparent',
        xl: 'white',
      }}
      borderRadius={'20px'}
      p={{ base: '0px', sm: '32px' }}
      h={'full'}
    >
      <Skeleton h={'30px'} w={'40%'} />

      <Flex flexDirection={'column'} gap={'10px'}>
        <Skeleton h={'10px'} w={'120px'} />

        <Skeleton h={'50px'} borderRadius={'lg'} />
      </Flex>

      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
        }}
        gap={'20px'}
      >
        <Flex flexDirection={'column'} gap={'10px'}>
          <Skeleton h={'10px'} w={'120px'} />

          <Skeleton h={'50px'} borderRadius={'lg'} />
        </Flex>

        <Flex flexDirection={'column'} gap={'10px'}>
          <Skeleton h={'10px'} w={'120px'} />

          <Skeleton h={'50px'} borderRadius={'lg'} />
        </Flex>
      </SimpleGrid>
      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
        }}
        gap={'20px'}
      >
        <Flex flexDirection={'column'} gap={'10px'}>
          <Skeleton h={'10px'} w={'120px'} borderRadius={'lg'} />

          <Skeleton h={'50px'} borderRadius={'lg'} />
        </Flex>

        <Flex flexDirection={'column'} gap={'10px'}>
          <Skeleton h={'10px'} w={'120px'} borderRadius={'lg'} />

          <Skeleton h={'50px'} borderRadius={'lg'} />
        </Flex>
      </SimpleGrid>
      <SimpleGrid
        columns={{
          base: 1,
          md: 2,
        }}
        gap={'20px'}
      >
        <Skeleton h={'50px'} borderRadius={'lg'} />

        <Skeleton h={'50px'} borderRadius={'50px'} />
      </SimpleGrid>
    </Flex>
  );
}
